import { render, staticRenderFns } from "./case-batch-allot.vue?vue&type=template&id=43456f64&scoped=true"
import script from "./case-batch-allot.vue?vue&type=script&lang=ts"
export * from "./case-batch-allot.vue?vue&type=script&lang=ts"
import style0 from "./case-batch-allot.vue?vue&type=style&index=0&id=43456f64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43456f64",
  null
  
)

export default component.exports